import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SubsidyPeriod } from '../../api/subsidy';

const prefix = 'tariffAndTuition.subsidies';

interface YearRow {
  year: number;
  periods: SubsidyPeriod[];
}

export function useSubsidyColumns() {
  const { t } = useTranslation();

  const columns: ColumnTable<YearRow>[] = useMemo(
    () => [
      {
        columnName: 'year',
        headerText: t(`${prefix}.year`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
        cellFormat: ({ row }) => <span className="fw-bold">{row.year}</span>,
      },
    ],
    [t],
  );

  return columns;
}

export type { YearRow };
